import { FC, PropsWithChildren, useReducer } from "react";
import { LanguageContext, languageReducer } from "./"; // Asegúrate de que las rutas sean correctas
import { labels } from "../../interfaces";

export interface LanguageState {
  labelLanguage: { [key: string]: string };
  language: string;
}

const Language_INITIAL_STATE: LanguageState = {
  labelLanguage: {},
  language: "en",
};

export const LanguageProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(languageReducer, Language_INITIAL_STATE);

  const setLabelLanguages = (language: string, labels: labels[]) => {
    const newlabelLanguage = labels.reduce((acc, label) => {
      acc[label.key] = label.translation;
      return acc;
    }, {} as { [key: string]: string });

    dispatch({
      type: "[Language] - Set labelLanguage",
      payload: { labelLanguage: newlabelLanguage, language },
    });
  };

  const getLabelLanguage = (key: string, defaultValue: string = "") => {
    return state.labelLanguage[key] || defaultValue;
  };

  return (
    <LanguageContext.Provider
      value={{
        ...state,
        setLabelLanguages,
        getLabelLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
